import { Button } from '@1trading/react/components/ui/button';
import { GradientIcon } from '@1trading/react/components/ui/gradient-icon';
import { FileClock } from 'lucide-react';
import type { ComponentProps } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { PageHeading, PageHeadingDescription, PageHeadingTitle } from '@/components/ui/page-heading';
import FuturesAppropriatenessTestLayout from '@/features/futures/layouts/appropriateness-test';

const FuturesAppropriatenessTestResultManualReviewPage = (props: ComponentProps<typeof FuturesAppropriatenessTestLayout>) => {
  const { t } = useTranslation();

  return (
    <FuturesAppropriatenessTestLayout className="-md:justify-center space-y-8" progress={1} size="sm" {...props}>
      <GradientIcon className="size-32 mx-auto" strokeWidth={1.5}>
        <FileClock />
      </GradientIcon>
      <PageHeading centered>
        <PageHeadingTitle>{t('FuturesAppropriatenessAssessment.result.manualReview.title')}</PageHeadingTitle>
        <PageHeadingDescription>{t('FuturesAppropriatenessAssessment.result.manualReview.description.underReview')}</PageHeadingDescription>
        <PageHeadingDescription>
          <Trans
            i18nKey="FuturesAppropriatenessAssessment.result.manualReview.description.contactSupport.text"
            values={{
              linkText: t('FuturesAppropriatenessAssessment.result.manualReview.description.contactSupport.linkText'),
            }}
            components={[
              <a
                key={import.meta.env.VITE_APP_SUPPORT_NEW_REQUEST_URL}
                href={import.meta.env.VITE_APP_SUPPORT_NEW_REQUEST_URL}
                target="_blank"
                className="relative underline hover:no-underline"
                rel="external noopener noreferrer"
              >
                {t('FuturesAppropriatenessAssessment.result.manualReview.description.contactSupport.linkText')}
              </a>,
            ]}
          />
        </PageHeadingDescription>
      </PageHeading>
      <Button size="lg" variant="primary" asChild>
        <a href={import.meta.env.VITE_APP_EXCHANGE_URL}>{t('buttons.exchange')}</a>
      </Button>
    </FuturesAppropriatenessTestLayout>
  );
};
FuturesAppropriatenessTestResultManualReviewPage.displayName = 'FuturesAppropriatenessTestResultManualReviewPage';

export default FuturesAppropriatenessTestResultManualReviewPage;
